// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RequestState, RowNew } from '../../../../components/Table/types';
import { flattenMints } from '../../../../utils/flattenMints';
import { useCustomSort } from '../../../../utils/sortByCreatedAt';
import { useGetMintQueries } from './useGetMintQueries';

export const useGetMintRows = () => {
  const mintQueries = useGetMintQueries();

  const queryDataMap = [
    { query: mintQueries.mintRequest, state: RequestState.Requested },
    { query: mintQueries.executedMint, state: RequestState.Executed },
    { query: mintQueries.rejectedMints, state: RequestState.Rejected },
  ];

  const isLoading = queryDataMap.some(({ query }) => query.isLoading);

  const rows = queryDataMap.reduce((acc: RowNew[], { query, state }) => {
    const dataArray = query.data || [];

    const newRows = flattenMints(dataArray, state);

    return acc.concat(newRows);
  }, []);
  const sortedByCreateTime = useCustomSort(rows);
  return {
    isLoading,
    rows: sortedByCreateTime,
  };
};
